const REL_COLORS = {
    authorized_reseller: '#d4af37',
    distributor: '#3b82f6',
    partner: '#22c55e',
    known_vendor: '#6b7280',
}

export default function VendorTable({ vendors, onRowClick }) {
    if (!vendors?.length) return <p style={{ color: '#64748b' }}>No vendors found.</p>

    return (
        <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                    <tr style={{ borderBottom: '1px solid rgba(148,163,184,0.2)' }}>
                        <th style={{ textAlign: 'left', padding: '12px 8px', color: '#94a3b8' }}>Name</th>
                        <th style={{ textAlign: 'left', padding: '12px 8px', color: '#94a3b8' }}>Country</th>
                        <th style={{ textAlign: 'left', padding: '12px 8px', color: '#94a3b8' }}>Relationship</th>
                        <th style={{ textAlign: 'left', padding: '12px 8px', color: '#94a3b8' }}>Contact</th>
                        <th style={{ textAlign: 'center', padding: '12px 8px', color: '#94a3b8' }}>Entries</th>
                    </tr>
                </thead>
                <tbody>
                    {vendors.map(v => (
                        <tr
                            key={v.id}
                            onClick={() => onRowClick?.(v)}
                            style={{
                                borderBottom: '1px solid rgba(148,163,184,0.1)',
                                cursor: onRowClick ? 'pointer' : 'default',
                                transition: 'background 0.15s',
                            }}
                            onMouseEnter={e => { if (onRowClick) e.currentTarget.style.background = 'rgba(212,175,55,0.05)' }}
                            onMouseLeave={e => { e.currentTarget.style.background = 'transparent' }}
                        >
                            <td style={{ padding: '12px 8px', color: '#f1f5f9', fontWeight: 600 }}>{v.name}</td>
                            <td style={{ padding: '12px 8px', color: '#94a3b8' }}>{v.country_of_origin || '—'}</td>
                            <td style={{ padding: '12px 8px' }}>
                                <span style={{
                                    background: `${REL_COLORS[v.relationship] || '#6b7280'}20`,
                                    color: REL_COLORS[v.relationship] || '#6b7280',
                                    padding: '2px 10px', borderRadius: '99px', fontSize: '11px', fontWeight: 600,
                                    textTransform: 'capitalize',
                                }}>{v.relationship?.replace(/_/g, ' ') || 'vendor'}</span>
                            </td>
                            <td style={{ padding: '12px 8px', color: '#94a3b8', fontSize: '13px' }}>
                                {v.contact_email || v.contact_name || '—'}
                            </td>
                            <td style={{ padding: '12px 8px', textAlign: 'center', color: '#d4af37', fontWeight: 700 }}>
                                {v.entries_count || 0}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}